import { render, staticRenderFns } from "./HeaderDefault.vue?vue&type=template&id=483d17d8&"
import script from "./HeaderDefault.vue?vue&type=script&lang=js&"
export * from "./HeaderDefault.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDefault.vue?vue&type=style&index=0&id=483d17d8&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports